module.exports = {"id":"199103","name":"Alexander Domínguez","rating":"72","photo":"./data/images/photos/3/199103.png","club":{"name":"Santa Fe","logo":"./data/images/clubs/SantaFe.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexanderDominguez0.json
// module id = 226
// module chunks = 0